<template>
  <div class="head">
    <div class="nav-wp">
      <div class="logo" @click="$router.push('/monitor/index')">XLAG.cn</div>
      <div class="nav">
        <div class="nav-item" v-for="(item, index) in navList" :key="index">
          <div v-if="item.children" class="nav-txt nav-dropdown" @click.stop="toggleCompareMenu">
            {{ item.title }}
            <i :class="['el-icon-arrow-down', { 'is-open': compareMenuOpen }]"></i>
            <div v-show="compareMenuOpen" class="dropdown-menu" @click.stop>
              <div class="dropdown-item" @click="goNav(child)" v-for="(child, i) in item.children" :key="i">
                {{ child.title }}
              </div>
            </div>
          </div>
          <div v-else class="nav-txt" @click="goNav(item)">{{ item.title }}</div>
          <div class="line" v-if="index != navList.length - 1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "",
  data() {
    return {
      compareMenuOpen: false,
      navList: [
        {
          title: "显示器",
          val: "/",
        },
        {
          title: "电视",
          val: "/tv/list",
        },
        {
          title: "比较工具",
          children: [
            { title: "显示器", val: "/compare" },
            { title: "电视", val: "/compare/tv" },
          ],
        },
      ],
    };
  },
  mounted() {
    document.addEventListener("click", this.closeCompareMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeCompareMenu);
  },
  methods: {
    toggleCompareMenu() {
      this.compareMenuOpen = !this.compareMenuOpen;
    },
    closeCompareMenu() {
      this.compareMenuOpen = false;
    },
    goNav(item) {
      this.compareMenuOpen = false;
      this.$router.push(item.val);
    },
  },
};
</script>
    
<style scoped>
.head {
  width: 100vw;
  height: 100px;
  background-color: #d00;
}
.nav-wp {
  height: 58px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 12px 16px 12px 12px;
  max-width: 1512px;
  width: 98%;
  top: 6px;
  left: 50%;
  transform: translate(-50%);
  z-index: 19;
  position: fixed;
  box-shadow: 0 0 15px #0000001a;
  border-radius: 12px;
  border: 1px solid #e1e1e1;
  background-color: #fafafafa;
}
.logo {
  height: 50px;
  line-height: 50px;
  font-family: "logo";
  font-size: 32px;
  padding: 0 4px;
  border-radius: 5px;
  color: #e70000;
  margin-right: 50px;
}
.logo:hover {
  cursor: pointer;
  color: #fff;
  background-color: #e70000;
}
.nav {
  display: flex;
  align-items: center;
}
.nav-item {
  display: flex;
  align-items: center;
}
.nav-txt {
  color: #e70000;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
}
.nav-txt:hover {
  color: #fff;
  background-color: #e70000;
}
.line {
  width: 1.5px;
  height: 20px;
  background-color: #e1e1e1;
  margin: 0 12px;
}
.nav-dropdown {
  position: relative;
  display: flex;
  align-items: center;
}
.nav-dropdown i {
  margin-left: 4px;
  font-size: 12px;
  transition: transform 0.2s;
}
.nav-dropdown i.is-open {
  transform: rotate(180deg);
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  min-width: 120px;
  background: #fff;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  overflow: hidden;
}
.dropdown-item {
  padding: 10px 16px;
  cursor: pointer;
  color: #333;
  white-space: nowrap;
}
.dropdown-item:hover {
  background: #f5f5f5;
  color: #e70000;
}
.dropdown-item:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}
</style>